export const environment = {
  stage: 'dev',
  production: false,
  identityPoolId: 'eu-central-1:947eab0f-cc1a-4e92-b127-436bfbed30f8',
  region: 'eu-central-1',
  assetsBucketName: '',
  userPoolId: 'eu-central-1_dB9MCr8nX',
  websocketUrl: 'wss://qgukqsuwj5.execute-api.eu-central-1.amazonaws.com/dev',
  websocketReconnectDelay: 2000,
  clientId: '7g62hsdjo0q2qdtijqv2g5b9ui',
  cognitoDomainPrefix: 'dev-draexlmaier-picturetocloud',
  cognitoRedirectUri: 'https://dev.data2cloud.draexlmaier.solutions/secure',
  cognitoLogoutUri: 'https://dev.data2cloud.draexlmaier.solutions/public',
  filesUrl: 'assets',
  restApiUrl: 'https://ac2556p138.execute-api.eu-central-1.amazonaws.com/dev',
};
